import { memo } from "react";
import { Drawer, Button, DatePicker, Select } from "antd";
import FormItemWrapper from "~/components/common/FormItemWrapper/FormItemWrapper";
import S2MosaicTypeSelector from "./S2MosaicTypeSelector/S2MosaicTypeSelector";
import { S2MosaicType } from "~/common/typescript/apis/S2MosaicAPIs";
import dayjs from "dayjs";

interface S2MosaicFilterPanelProps {
  visible: boolean;
  onClose: () => void;
  year: number;
  setYear: (year: number) => void;
  type: S2MosaicType;
  setType: (type: S2MosaicType) => void;
  month?: number;
  setMonth: (month?: number) => void;
  dateRange: [string, string] | [null, null];
  setDateRange: (range: [string, string] | [null, null]) => void;
  onSearch: () => void;
}

const S2MosaicFilterPanel: React.FC<S2MosaicFilterPanelProps> = ({
  visible,
  onClose,
  year,
  setYear,
  type,
  setType,
  month,
  setMonth,
  dateRange,
  setDateRange,
  onSearch,
}) => {
  return (
    <Drawer
      title="Tìm kiếm ảnh vệ tinh"
      placement="right"
      closable={true}
      onClose={onClose}
      open={visible}
      width={375} // Mobile width
      style={{ position: 'absolute' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <FormItemWrapper label="Loại ảnh ghép">
          <S2MosaicTypeSelector value={type} onChange={setType} />
        </FormItemWrapper>
        {type === S2MosaicType.Day ? (
          <>
            <FormItemWrapper label="Khoảng thời gian">
              <DatePicker.RangePicker
                onChange={(dates, dateStrings) => {
                  setDateRange([dateStrings[0] || null, dateStrings[1] || null]);
                }}
                value={
                  dateRange[0] && dateRange[1]
                    ? [dayjs(dateRange[0]), dayjs(dateRange[1])]
                    : [null, null]
                }
              />
            </FormItemWrapper>
          </>
        ) : (
          <>
            <FormItemWrapper label="Năm">
              <div>
                <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                  <Button type={year == 2025 ? 'primary' : 'default'} onClick={() => setYear(2025)}>2025</Button>
                  <Button type={year == 2024 ? 'primary' : 'default'} onClick={() => setYear(2024)}>2024</Button>
                  <Button type={year == 2023 ? 'primary' : 'default'} onClick={() => setYear(2023)}>2023</Button>
                </div>
              </div>
            </FormItemWrapper>
            {type === S2MosaicType.Month && (
              <FormItemWrapper label="Tháng">
                <Select
                  style={{ width: '100%' }}
                  placeholder="Tất cả các tháng"
                  allowClear
                  value={month}
                  onChange={(val) => setMonth(val !== undefined ? Number(val) : undefined)}
                  options={[
                    { label: 'Tất cả các tháng', value: undefined as any },
                    ...Array.from({ length: 12 }, (_, i) => ({
                      label: `Tháng ${i + 1}`,
                      value: i + 1,
                    })),
                  ]}
                />
              </FormItemWrapper>
            )}
          </>
        )}
        <Button type="primary" onClick={onSearch}>Tìm kiếm</Button>
      </div>
    </Drawer>
  );
};

export default memo(S2MosaicFilterPanel);